<template>
      <div>
            <div slot="headline" class="fs5 lh125 fw7 c1 mb2">{{ $t("holder") }}</div>
            <core-entity-card :entity="holder" :isExpanded="false"/>
      </div>
</template>

<script>
import CoreEntityCard from "@/modules/core/components/CoreEntityCard/"

export default {
	components: { CoreEntityCard },
	props: {
		holder: {
			type: Object,
			required: true,
			default: () => {}
		}
	}
}
</script>
